// import React, { useState } from 'react';
// import { AddAppointment, Container1, Container2, BoxContainer, BoxInner1, InnerAppointments, Text, Texts, Text2, DataContainer, StatusData, LineContainer, MenuContainer, PaymentContainer, Dot, PagingContainer, InnerBox } from './Styles';
// import { ReactComponent as Add } from '../../../../../../src/assets/images/add-square.svg';
// import InputSelect from 'src/components/shared/Form/Select';
// import { ReactComponent as MenuIcon } from '../../../../../assets/images/more.svg';
// import Paging from 'src/components/App/Paging';
// import { Box, Typography, alpha, Menu, MenuItem } from '@mui/material';
// import NoDataFound from '../../NoDataFound/NoDataFound';
// import PaymentTabForm from '../Forms/PaymentTabForm';
// import DialogBox from 'src/components/shared/Dialog/DialogBox';
// import useResponsive from 'src/components/hooks/useResponsive';
// import { ReactComponent as Edit } from '../../../../../../src/assets/images/edit-2.svg';
// import theme from 'src/config/theme';


// const PaymentCard = ({ payment = [], page, perPage, setPage, totalCount, fetchPayments, handleRefundOpen }) => {
//     const [open, setOpen] = useState(false);
//     const handleOpen = () => setOpen(true);
//     const handleClose = () => setOpen(false);
//     const [anchorEl, setAnchorEl] = useState(null);
//     const [selectedRow, setSelectedRow] = useState(null);
//     const { isMobile, isTablet, isDesktop } = useResponsive();
//     const Width = isMobile || isTablet ? 18 : 24;
//     const Height = isMobile || isTablet ? 18 : 24;
//     const handleMenuOpen = (event, item) => {
//         setAnchorEl(event.currentTarget);
//         setSelectedRow(item);
//     };
//     const handleMenuClose = () => {
//         setAnchorEl(null);
//         setSelectedRow(null);
//     };
//     const data = payment.map((paymentData) => {
//         const isRefund = paymentData.amount < 0;

//         return {
//             paymentId: paymentData.id,
//             paymentfor: paymentData.paymentFor,
//             amount: (
//                 <Box sx={{ color: isRefund ? 'red' : 'green', fontWeight: 'bold' }}>
//                     {isRefund ? `- ${Math.abs(paymentData.amount)}` : `+ ${paymentData.amount}`}
//                 </Box>
//             ),
//             addedDate: new Date(paymentData.date).toLocaleDateString('en-GB', {
//                 day: '2-digit',
//                 month: 'short',
//                 year: 'numeric'
//             }),
//             paymenttype: paymentData.type,
//             paymentmethod: paymentData.method,
//         };
//     });

//     const actions = (row) => {
//         if (!row) return [];

//         return row.paymenttype === 'credit'
//             ? [
//                 {
//                     label: "Refund",
//                     icon: <Edit width={Width} height={Height} />,
//                     onClick: () => handleRefundOpen(row.paymentId, row.paymenttype),
//                 }
//             ]
//             : [];
//     };
//     return (
//         <>
//             <Container1>
//                 <AddAppointment
//                     startIcon={<Add width="18px" height="18px" />}
//                     onClick={handleOpen}
//                 >Add Payment</AddAppointment>
//                 <InputSelect
//                     placeholder="Sort By"
//                     // options={staffOptions}
//                     // name="automaticTaskAssignTo"
//                     variant="outlined"
//                     // value={values.automaticTaskAssignTo}
//                     // onChange={(value) => setFieldValue('automaticTaskAssignTo', value)}
//                     // showNone={false}
//                     sx={{
//                         '& .MuiOutlinedInput-root': {
//                             height: '44px',
//                             display: 'flex',
//                             alignItems: 'center',
//                             borderRadius: '8px',
//                             minWidth: '168px',
//                             padding: '10px 12px',
//                         },
//                     }}
//                 />

//             </Container1>
//             <Container2>
//                 <InnerAppointments>
//                     <InnerBox isEmpty={data.length === 0}>
//                         {data.length === 0 ? (
//                             <NoDataFound
//                                 title="No Payments Found!"
//                                 buttonText="Add Payment"
//                                 buttonIcon={Add}
//                                 onClick={handleOpen}
//                             />

//                         ) : (
//                             <>
//                                 {data.map((item) => (
//                                     <BoxContainer key={item.paymentId}>
//                                         <BoxInner1>
//                                             <DataContainer>
//                                                 <Text2>{item.amount}</Text2>
//                                                 <PaymentContainer>
//                                                     <Texts>{item.paymentfor}</Texts>
//                                                     <Dot />
//                                                     <Texts>{item.paymenttype}</Texts>
//                                                     <Dot />
//                                                     <Texts>{item.paymentmethod}</Texts>
//                                                 </PaymentContainer>

//                                             </DataContainer>

//                                         </BoxInner1>
//                                         <LineContainer />
//                                         <BoxInner1>
//                                             <DataContainer>
//                                                 <Text>{item.addedDate}</Text>
//                                                 <Texts>Date & Time</Texts>
//                                             </DataContainer>
//                                             <MenuContainer onClick={(event) => handleMenuOpen(event, item)}
//                                                 isActive={selectedRow === item}>
//                                                 <MenuIcon />
//                                             </MenuContainer>
//                                             <Menu
//                                                 anchorEl={anchorEl}
//                                                 open={Boolean(anchorEl)}
//                                                 onClose={handleMenuClose}
//                                                 sx={{
//                                                     "& .MuiPaper-root": {
//                                                         width: "176px",
//                                                         borderRadius: "12px",
//                                                         padding: "4px 18px",
//                                                         backgroundColor: "red",
//                                                         border: `1px solid ${alpha(theme.palette.gery.black, 0.1)}`,
//                                                         backgroundColor: theme.palette.gery.white,
//                                                         display: 'flex',
//                                                         justifyContent: 'center',
//                                                         alignItems: 'center',
//                                                         gap: '14px',
//                                                     }
//                                                 }}
//                                             >
//                                                 {actions.map((action, index) => (
//                                                     <MenuItem key={index} onClick={() => {
//                                                         action.onClick(selectedRow);
//                                                         handleMenuClose();
//                                                     }}>
//                                                         <Box display="flex" alignItems="center" gap={1}>
//                                                             {action.icon} <Typography>{action.label}</Typography>
//                                                         </Box>
//                                                     </MenuItem>
//                                                 ))}
//                                             </Menu>
//                                         </BoxInner1>
//                                     </BoxContainer>
//                                 ))}
//                             </>
//                         )}


//                     </InnerBox>
//                     <PagingContainer>
//                         <Paging
//                             page={page}
//                             perPage={perPage}
//                             count={totalCount || 0}
//                             onChange={(newPage) => setPage(newPage)}
//                         />
//                     </PagingContainer>
//                 </InnerAppointments>
//                 <DialogBox open={open} onClose={handleClose} >
//                     <PaymentTabForm onClose={handleClose} fetchPayments={fetchPayments} />
//                 </DialogBox>
//             </Container2>
//         </>
//     )
// }

// export default PaymentCard

import React, { useState } from 'react';
import {
    AddAppointment, Container1, Container2, BoxContainer, BoxInner1,
    InnerAppointments, Text, Texts, Text2, DataContainer, LineContainer,
    MenuContainer, PaymentContainer, Dot, PagingContainer, InnerBox
} from './Styles';
import { ReactComponent as Add } from '../../../../../../src/assets/images/add-square.svg';
import { ReactComponent as MenuIcon } from '../../../../../assets/images/more.svg';
import { ReactComponent as Edit } from '../../../../../../src/assets/images/edit-2.svg';
import InputSelect from 'src/components/shared/Form/Select';
import Paging from 'src/components/App/Paging';
import NoDataFound from '../../NoDataFound/NoDataFound';
import PaymentTabForm from '../Forms/PaymentTabForm';
import DialogBox from 'src/components/shared/Dialog/DialogBox';
import useResponsive from 'src/components/hooks/useResponsive';
import { Box, Typography, alpha, Menu, MenuItem } from '@mui/material';
import theme from 'src/config/theme';
const PaymentCard = ({ payment = [], page, perPage, setPage, totalCount, fetchPayments, handleRefundOpen }) => {
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleMenuOpen = (event, item) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(item);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedRow(null);
    };

    const { isMobile, isTablet } = useResponsive();
    const Width = isMobile || isTablet ? 18 : 24;
    const Height = isMobile || isTablet ? 18 : 24;

    const data = payment.map((paymentData) => {
        const isRefund = paymentData.amount < 0;
        return {
            paymentId: paymentData.id,
            paymentfor: paymentData.paymentFor,
            amount: (
                <Box sx={{ color: isRefund ? 'red' : 'green', fontWeight: 'bold' }}>
                    {isRefund ? `- ${Math.abs(paymentData.amount)}` : `+ ${paymentData.amount}`}
                </Box>
            ),
            addedDate: new Date(paymentData.date).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            }),
            paymenttype: paymentData.type,
            paymentmethod: paymentData.method,
        };
    });


    const actions = (row) => {
        if (!row) return [];
        return row.paymenttype === 'credit'
            ? [
                {
                    label: "Refund",
                    icon: <Edit width={Width} height={Height} />,
                    onClick: () => handleRefundOpen(row.paymentId, row.paymenttype),
                }
            ]
            : [];
    };

    return (
        <>
            <Container1>
                <AddAppointment
                    startIcon={<Add width="18px" height="18px" />}
                    onClick={handleOpen}
                >
                    Add Payment
                </AddAppointment>


            </Container1>

            <Container2>
                <InnerAppointments>
                    <InnerBox isEmpty={data.length === 0}>
                        {data.length === 0 ? (
                            <NoDataFound
                                title="No Payments Found!"
                                buttonText="Add Payment"
                                buttonIcon={Add}
                                onClick={handleOpen}
                            />
                        ) : (
                            <>
                                {data.map((item) => (
                                    <BoxContainer key={item.paymentId}>
                                        <BoxInner1>
                                            <DataContainer>
                                                <Text2>{item.amount}</Text2>
                                                <PaymentContainer>
                                                    <Texts>{item.paymentfor}</Texts>
                                                    <Dot />
                                                    <Texts>{item.paymenttype}</Texts>
                                                    <Dot />
                                                    <Texts>{item.paymentmethod}</Texts>
                                                </PaymentContainer>
                                            </DataContainer>
                                        </BoxInner1>

                                        <LineContainer />

                                        <BoxInner1>
                                            <DataContainer>
                                                <Text>{item.addedDate}</Text>
                                                <Texts>Date & Time</Texts>
                                            </DataContainer>

                                            <MenuContainer
                                                onClick={(event) => {
                                                    if (item.paymenttype === 'credit') {
                                                        handleMenuOpen(event, item);
                                                    }
                                                }}
                                                isActive={selectedRow === item}
                                                style={{
                                                    opacity: item.paymenttype === 'credit' ? 1 : 0.4,
                                                    pointerEvents: item.paymenttype === 'credit' ? 'auto' : 'none',
                                                }}
                                            >
                                                <MenuIcon />
                                            </MenuContainer>

                                            <Menu
                                                anchorEl={anchorEl}
                                                open={Boolean(anchorEl)}
                                                onClose={handleMenuClose}
                                                sx={{
                                                    "& .MuiPaper-root": {
                                                        width: "176px",
                                                        borderRadius: "12px",
                                                        padding: "4px 18px",
                                                        border: `1px solid ${alpha(theme.palette.gery.black, 0.1)}`,
                                                        backgroundColor: theme.palette.gery.white,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: '14px',
                                                    },
                                                }}
                                            >
                                                {(selectedRow ? actions(selectedRow) : []).map((action, index) => (
                                                    <MenuItem key={index} onClick={() => {
                                                        action.onClick(selectedRow);
                                                        handleMenuClose();
                                                    }}>
                                                        <Box display="flex" alignItems="center" gap={1}>
                                                            {action.icon}
                                                            <Typography>{action.label}</Typography>
                                                        </Box>
                                                    </MenuItem>
                                                ))}
                                            </Menu>
                                        </BoxInner1>
                                    </BoxContainer>
                                ))}
                            </>
                        )}
                    </InnerBox>

                    <PagingContainer>
                        <Paging
                            page={page}
                            perPage={perPage}
                            count={totalCount || 0}
                            onChange={(newPage) => setPage(newPage)}
                        />
                    </PagingContainer>
                </InnerAppointments>

                <DialogBox open={open} onClose={handleClose}>
                    <PaymentTabForm onClose={handleClose} fetchPayments={fetchPayments} />
                </DialogBox>
            </Container2>
        </>
    );
};

export default PaymentCard;
